<script lang="ts" setup>
import BtnBack from '@components/ui/footer/actions/BtnBack.vue'
import BtnEmptyCart from '@components/ui/footer/actions/BtnEmptyCart.vue'
import { useCartActions } from '@composables/useCartActions'

const { cartUnits } = useCartActions()
</script>

<template>
  <div class="gap-vw-16 flex flex-row items-center justify-end">
    <div class="w-1/2"></div>

    <BtnBack v-if="!cartUnits" />
    <BtnEmptyCart v-else />
  </div>
</template>
